module.exports = __webpack_public_path__ + "img/zhuti-05.80aca866.png";